import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function PortalSuccess() {
  const [searchParams] = useSearchParams();
  const studentId = searchParams.get('student_id');

  useEffect(() => {
    // Auto-close window after a few seconds
    const timer = setTimeout(() => {
      window.close();
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="max-w-md w-full space-y-8 p-8">
        <div className="text-center">
          <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-green-100 dark:bg-green-900/30">
            <svg
              className="h-6 w-6 text-green-600 dark:text-green-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <h2 className="mt-6 text-3xl font-bold tracking-tight text-gray-900 dark:text-white">
            Payment Information Updated
          </h2>
          <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
            Please close this window when you've successfully updated your information.
          </p>
          <p className="mt-4 text-xs text-gray-500 dark:text-gray-500">
            This window will automatically close in a few seconds.
          </p>
          <button
            onClick={() => window.close()}
            className="mt-6 inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500"
          >
            Close Window
          </button>
        </div>
      </div>
    </div>
  );
}
